module.exports = require('./lib/_stream_duplex.js');



// WEBPACK FOOTER //
// /usr/local/www/sites/www.lactame.com/node/grm-data/git/cheminfo-js/molecular-formula/node_modules/readable-stream/duplex-browser.js